// import {
//     mapState,
// } from 'vuex'
export default {
    name: 'onlineCustomerDialog',
    props: {
        mobile: {
            type: Number | String,
            default: ''
        },
    },
    data () {
        return {
            showStatus: false,
        }
    },
    created () { },
    activated () { },
    mounted () { },
    methods: {
        open () {
            this.showStatus = true
        },
        close () {
            this.showStatus = false
        },
        callStore () {
            window.location.href = 'tel://' + this.mobile
        },
        jumpApp () {
            this.$router.push('/appDownload')
        }
    },
    computed: {}
}
